import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'panel',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="panel__prefix"><ng-content select="[panel-prefix]" /></div>
    <div class="panel__body"><ng-content select="[panel-body]" /></div>
    <div class="panel__suffix"><ng-content select="[panel-suffix]" /></div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'panel'
  }
})
export class PanelComponent {}
